import type { RequestParams } from "./http";

import { getJson, postForm, postJson } from "./http";

/** Обёртка, в которой API it4 возвращает данные */
export interface It4Response<TData> {
    status: number;
    data: TData;
}

function stageUrl(path: string): string {
    return `${import.meta.env.VITE_STAGE_API_HOST}${path}`;
}

/** POST-запрос к API it4 */
export function stagePost<TResponse>(path: string, body: unknown): Promise<TResponse> {
    return postJson<TResponse>(stageUrl(path), body);
}

/** POST-запрос к API it4 с form-urlencoded телом */
export function stagePostForm<TResponse>(path: string, body?: RequestParams): Promise<TResponse> {
    return postForm<TResponse>(stageUrl(path), body);
}

/** GET-запрос к API it4 */
export function stageGet<TResponse>(path: string, params: RequestParams): Promise<TResponse> {
    return getJson<TResponse>(stageUrl(path), params);
}
